// vanilla js web component, custom element <plans-preview>

customElements.define('plans-preview', class extends HTMLElement {

  /**
   * The class constructor object
   */
  constructor() {

    // Always call super first in constructor
    super();

    this.plans = [];

    this.isDragging = false;
    this.z = 1;
    this.x = 0;
    this.y = 0;
    this.lx = 0;
    this.ly = 0;

    this.download = this.getAttribute('download') || false;
    this.lock = this.getAttribute('lock') || false;
    this.unlock = this.getAttribute('unlock') || false;

    if (localStorage.getItem('plansUnlocked')) {
      this.lock = false
    }

    var parser = new DOMParser();

    if (this.lock == true) {
      // Get the current domain
      const domain = window.location.origin;

      // URL of the contact page on the current domain
      const url = `${domain}/plans/unlock`;

      fetch(url)
        .then(response => response.text()) // Convert response to text
        .then(html => {
          // Parse the HTML
          const doc = parser.parseFromString(html, 'text/html');
          var unlock_form = doc.querySelector('form');
          var formwrap = document.createElement('div');
          formwrap.classList.add('absolute', 'top-0', 'left-0', 'w-full', 'h-full', 'flex', 'justify-center', 'items-center');
          formwrap.appendChild(unlock_form);
          this.querySelectorAll('picture').forEach((picture, i) => {
            if (this.lock && i > this.unlock) {
              picture.appendChild(formwrap);
            }
          });
        })
        .catch(error => {
          console.error('Error fetching the contact page:', error);
          var unlock_form = false;
        });
    }

    // add imgs from dom to array
    this.querySelectorAll('picture').forEach((picture, i) => {
      picture.classList.add('hidden');
      picture.style.webkitTouchCallout = 'none';
      if (this.lock == true && i > this.unlock) {
        picture.querySelector('img').classList.add('blur');
      }
      picture.dataset.highres = this.querySelectorAll('h3')[i].getAttribute('data-highres');
      picture.style.cursor = 'zoom-in';
      this.plans.push(picture);
    });
    this.plans[0].classList.remove('hidden', 'absolute');

    // create a button for each plan, add to a div
    let buttons = document.createElement('div');
    buttons.id = 'plans-buttons';
    buttons.classList.add('flex', 'justify-center', 'm-4');
    this.plans.forEach((plan, i) => {
      let button = document.createElement('button');
      button.dataset.plan = i;
      button.classList.add('inline-block', 'px-2', 'py-1', 'm-1', 'border', 'border-gray-400', 'rounded', 'bg-gray-100', 'hover:bg-gray-200', 'text-gray-600', 'hover:text-primary-500');
      button.innerHTML = plan.querySelector('img').getAttribute('alt');
      if (i == 0) {
        button.classList.add('text-primary-500');
        button.classList.remove('text-gray-600');
      }
      buttons.appendChild(button);
    });
    
    if (this.download) {
      let download = document.createElement('a');
      download.href = this.download;
      download.classList.add('inline-block', 'px-2', 'py-1', 'm-1', 'border', 'border-gray-400', 'rounded', 'bg-gray-100', 'hover:bg-gray-200', 'text-gray-600', 'hover:text-primary-500');
      download.innerText = "Download Plans";
      buttons.appendChild(download);
    }

    this.innerHTML =
      `
      ${buttons.outerHTML}
      <div class="relative mx-auto pb-12">
      ${this.plans.map(plan => plan.outerHTML).join('')}
      ${this.download ? `<p class="text-center text-gray-600">Right click on the plans to download.</p>` : ''}
      </div>
      <plans-modal class="fixed w-screen h-screen top-0 left-0 flex justify-center items-center z-50" hidden></plans-modal>
      `;

  }

  handleEvent(event) {
    this[`on${event.type}`](event);
  }

  onclick(event) {
    if (event.target.closest('button[data-plan]')) {
      let plan = event.target.closest('button[data-plan]').dataset.plan;
      this.hidePlans();
      this.showPlan(plan);
    }
    else if (event.target.closest('picture')) {
      this.zoomPlan(event.target.closest('picture'));
    }
    else if (event.target.closest('button#zoom-out')) {
      this.zoomOut();
    }
    else if (event.target.closest('button#zoom-in')) {
      this.zoomIn();
    }
    else if (event.target.closest('button#zoom-reset')) {
      this.zoomReset();
    }
    else if (event.target.closest('#closeButton')) {
      this.querySelector('plans-modal').hidden = true;
    }
    else if (event.target.id == 'backdrop') {
        this.querySelector('plans-modal').hidden = true;
    }
  }

  oncontextmenu(event) {
    event.preventDefault();
    if (this.download) {
      window.location.href = this.download;
    }
  }

  onmousedown(event) {
    if (event.target.closest('plans-modal')) {
      this.startDragging(event);
    }
  }

  ontouchstart(event) {
    if (event.target.closest('plans-modal')) {
      this.startDragging(event);
    }
  }

  onmousemove(event) {
    if (event.target.closest('plans-modal')) {
      this.drag(event);
    }
  }

  ontouchmove(event) {
    if (event.target.closest('plans-modal')) {
      this.drag(event);
    }
  }

  onmouseup(event) {
    if (event.target.closest('plans-modal')) {
      this.stopDragging(event);
    } 
  }

  ontouchend(event) {
    if (event.target.closest('plans-modal')) {
      this.stopDragging(event);
    }
  }

  onsubmit(event) {
      event.preventDefault();
      console.log('submit', event);

      const formData = new FormData(event.target);

      fetch(event.target.action, {
          method: 'POST',
          body: formData,
          headers: {
              'X-Requested-With': 'XMLHttpRequest'
          }
      })
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json();
      })
      .then(data => {
          console.log('success', data);
          if (data.success) {
              this.unlockPlans();
              let now = new Date().toISOString();
              // set localstorage plansUnlocked to current unix timestamp
              localStorage.setItem("plansUnlocked", `${now}`);
          } else {
              this.showErrors(data);
          }
      })
      .catch(error => {
          console.log('error', error);
          this.showErrors(error);
      });
  }

  /**
    * functions to move and zoom plans
    */

    startDragging(event) {
      if (event.type == 'touchstart') {
        this.isDragging = true;
        this.lx = event['touches'][0].clientX;
        this.ly = event['touches'][0].clientY;
      }
      else {
        event.preventDefault();
        this.isDragging = true;
        this.lx = event.clientX;
        this.ly = event.clientY;
      }
    }

  drag(event) {
    if (this.isDragging) {
      if (event.type == 'touchmove') {
        this.dx = event['touches'][0].clientX - this.lx;
        this.dy = event['touches'][0].clientY - this.ly;
        this.lx = event['touches'][0].clientX;
        this.ly = event['touches'][0].clientY;
      }
      else {
        this.dx = event.clientX - this.lx;
        this.dy = event.clientY - this.ly;
        this.lx = event.clientX;
        this.ly = event.clientY;
      }
      this.x += this.dx;
      this.y += this.dy;
      this.zoom();
    }
   
    }

    stopDragging(event) {
      this.isDragging = false;
    }

    zoom() {
      const img = this.querySelector('plans-modal img');
      img.style.left = this.x + 'px';
      img.style.top = this.y + 'px';
      img.style.transform = `scale(${this.z})`;
    }

    zoomIn() {
      this.z = this.z * 1.25
      this.zoom();
    }

    zoomOut() {
      this.z = this.z / 1.25
      this.zoom();
    }

    zoomReset() {
      this.z = 1;
      this.zoom();
    }

  /**
    * function to hide a plan
    * @param {object} plan - the plan to hide
    */
  hidePlans() {
    this.querySelectorAll('picture').forEach(picture => {
      picture.classList.add('hidden');
    });
    this.querySelectorAll('button[data-plan]').forEach(button => {
      button.classList.add('text-gray-600');
      button.classList.remove('text-primary-500');
    });
  }

  unlockPlans() {
    this.querySelectorAll('picture').forEach(picture => {
        picture.querySelector('img').classList.remove('blur');
    });
    this.querySelector('form').parentElement.remove();
  }

  showErrors(response) {
    console.log(response);
  }

  /**
    * function to show a plan
    * @param {object} plan - the plan to show
    */
  showPlan(plan) {
    this.querySelectorAll('picture')[plan].classList.remove('hidden');
    this.querySelectorAll('button[data-plan]')[plan].classList.add('text-primary-500');
    this.querySelectorAll('button[data-plan]')[plan].classList.remove('text-gray-600');
  }

 /**
  * function to zoom in on a plan
  * @param {object} plan - the plan to zoom in on
  */
  zoomPlan(plan) {
    let highres = plan.dataset.highres;
    // use highres as the src for the picture element (plan) if it exists
    if (highres) {
      this.querySelector('plans-modal').hidden = false;
      this.querySelector('plans-modal').innerHTML = `
      <style>
        #backdrop {
          backdrop-filter: blur(7px);
          background: rgba(0,0,0,0.7);
          bottom: 0;
          left: 0;
          position: fixed;
          right: 0;
          top: 0;
          padding: 1em;
          transition: all ease-in-out 0.1s;
          z-index: -1;
          display: flex;
          align-content: center;
          justify-content: center;
          align-items: center;
          opacity: 1;
          pointer-events: all;
          z-index: 100;
        }

        #modal {
          transition: all ease-in-out 0.25s 0.1s;
          border-radius: 3px;
          filter: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
          opacity: 1;
          pointer-events: all;
          z-index: 100;
          display: block;
          width: 100%;
          height: 100%;
          max-width: 100vw;
          max-height: 100vh;
        }

        #closeButton,
        #zoom-in,
        #zoom-out,
        #zoom-reset {
          backdrop-filter: blur(7px);
          background-color: #000;
          background-color: rgba(0,0,0,0.50);
          border: none;
          color: #fff;
          color: rgba(255,255,255,0.8);
          cursor: pointer;
          transition: all 0.5s ease-in-out;
          z-index: 101;
        }
        
        #zoom-in,
        #zoom-out,
        #zoom-reset {
          border-radius: 10px;
          padding: 0 1em;
        }

        #closeButton:hover,
        #zoom-in:hover,
        #zoom-out:hover,
        #zoom-reset:hover {
          background-color: #000;
          background-color: rgba(0,0,0,0.75);
          color: #fff;
        }

        #closeButton {
          border-radius: 50%;
          display: flex;
          justify-content: center;
          height: 25px;
          width: 25px;
          position: absolute;
          right: 10px;
          top: 10px;
          align-items: center;
          
        }

        #closeButton > svg {
          height: 25px;
          margin-left: 1px;
          width: 25px;
        }

        :host {
          display: block;
        }

        :host([hidden]) #backdrop,
        :host([hidden]) #modal {
          opacity: 0;
          pointer-events: none;
          z-index: 0;
        }

      </style>
      <div id="backdrop">
          <div id="modal">
            <div class="bg-white w-full h-full overflow-hidden relative flex items-center justify-center select-none">
                <img class="block absolute cursor-grab select-none shadow-lg border border-gray-400 transition-transform duration-300 ease-in-out" src="${highres}" />
                <div class="absolute bottom-0 left-0 right-0 flex items-center justify-center gap-2 my-2">
                  <button id="zoom-in">zoom in</button>
                  <button id="zoom-reset">reset</button>
                  <button id="zoom-out">zoom out</button>
                </div>
             </div>
            <button id="closeButton">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 320 512"><path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"/></svg>
            </button>
          </div>
      </div>
      `;
    }
  }


  /**
   * Runs each time the element is appended to or moved in the DOM
   */
  connectedCallback() {
    this.addEventListener('click', this);
    this.addEventListener('contextmenu', this);
    this.addEventListener('submit', this);
    this.addEventListener('mousedown', this);
    this.addEventListener('mousemove', this);
    this.addEventListener('mouseup', this);
    this.addEventListener('touchstart', this, { passive: true });
    this.addEventListener('touchmove', this, { passive: true });
    this.addEventListener('touchend', this);
  }

  /**
   * Runs when the element is removed from the DOM
   */
  disconnectedCallback() {
    this.removeEventListener('click', this);
    this.removeEventListener('contextmenu', this);
    this.removeEventListener('submit', this);
    this.removeEventListener('mousedown', this);
    this.removeEventListener('mousemove', this);
    this.removeEventListener('mouseup', this);
    this.removeEventListener('touchstart', this);
    this.removeEventListener('touchmove', this);
    this.removeEventListener('touchend', this);
  }

});

